"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _utils = require('shared/store/utils');
var _helpers = require('shared/actions/helpers');
var _log = require('shared/log');
var _uuid = require('shared/services/uuid');
var _store = require('shared/store');
var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _browserTransport = require('shared/services/directUpload/browserTransport');
var _uploadFileWithFallback = require('shared/services/directUpload/uploadFileWithFallback');















const loadPatientConversationByCodeActions =
  _utils.createAsyncActions('LoadPatientConversationByCode')
const markPatientConversationSeenActions =
  _utils.createAsyncActions('MarkPatientConversationSeen')
const getPatientConversationMessagesActions =
  _utils.createAsyncActions('GetPatientConversationMessages')
const sendPatientConversationMessageActions =
  _utils.createAsyncActions('SendPatientConversationMessage')
const sendPatientConversationFileActions =
  _utils.createAsyncActions('SendPatientConversationMessage (File)')
const uploadPatientFileActions = _utils.createAsyncActions('HTTP patient file upload')
const renewPatientConversationLinkActions =
  _utils.createAsyncActions('HTTP patient link renewal')
// A message written while the page is offline: it waits, then goes with
// sendPatientConversationMessage (same key and lid) once the page reconnects.
const patientMessageWaitingAction = _utils.createAction


('PatientConversationMessageWaiting')
const addPatientMessageReactionActions =
  _utils.createAsyncActions('AddPatientMessageReaction')
const removePatientMessageReactionActions =
  _utils.createAsyncActions('RemovePatientMessageReaction')
// The patient's own reaction shows at once (Mine: true adds it, false takes
// it away), before the server answers; a refusal puts it back.
const patientReactionToggledAction = _utils.createAction




('PatientMessageReactionToggled')
// The connection dropped: sends still waiting for the server's answer can't
// be confirmed, so they show as not sent, with Retry.
const patientSendsInterruptedAction = _utils.createAction

('PatientConversationSendsInterrupted')

 const actionCreators = {
  loadPatientConversationByCodeActions,
  markPatientConversationSeenActions,
  getPatientConversationMessagesActions,
  sendPatientConversationMessageActions,
  sendPatientConversationFileActions,
  uploadPatientFileActions,
  renewPatientConversationLinkActions,
  patientMessageWaitingAction,
  patientSendsInterruptedAction,
  addPatientMessageReactionActions,
  removePatientMessageReactionActions,
  patientReactionToggledAction,
}; exports.actionCreators = actionCreators

const loadPatientConversationByCode = (req) =>
  _helpers.wsCommand(
    'LoadPatientConversationByCode',
    loadPatientConversationByCodeActions,
    req,
    null,
  )

const markPatientConversationSeen = (req) =>
  _helpers.wsCommand(
    'MarkPatientConversationSeen',
    markPatientConversationSeenActions,
    req,
    null,
  )

const getPatientConversationMessages = (req) =>
  _helpers.wsCommand(
    'GetPatientConversationMessages',
    getPatientConversationMessagesActions,
    req,
    null,
  )

// How long a send waits for the server, longer than the client's default:
// a busy server can take a while to answer a burst of sends.
const SEND_TTL_MS = 45000

const sendOnce = (req, lid) =>
  _helpers.wsCommand(
    'SendPatientConversationMessage',
    sendPatientConversationMessageActions,
    req,
    { lid },
    undefined,
    SEND_TTL_MS,
  )

const isTimeout = (e) => e instanceof _log.CommandError && _optionalChain([e, 'access', _ => _.extra, 'optionalAccess', _2 => _2.Status]) === 'timeout'

/* Sends text under the page's MessageKey. A send the server didn't answer in
 * time goes once more under the same key, which returns the message if the
 * first one was stored, so a late answer never leaves it "Not sent". A retry
 * passes the lid of the row it sends again. */
const sendPatientConversationMessage = (req, lid = _uuid.uuidv4.call(void 0, )) =>
  sendOnce(req, lid).catch((e) => {
    if (!req.MessageKey || !isTimeout(e)) throw e
    return sendOnce(req, lid)
  })

const holdPatientConversationMessage = (req, lid = _uuid.uuidv4.call(void 0, )) =>
  _store.dispatch.call(void 0, patientMessageWaitingAction({ Request: req, lid }))

/* Adds (mine) or removes the patient's reaction: shown at once, put back
 * if the server refuses. The server then resends the message with its
 * counts. */
const togglePatientMessageReaction = (
  req,
  mine,
) => {
  _store.dispatch.call(void 0, patientReactionToggledAction({ ...req, Mine: mine }))
  const sent = mine
    ? _helpers.wsCommand('AddPatientMessageReaction', addPatientMessageReactionActions, req, null)
    : _helpers.wsCommand('RemovePatientMessageReaction', removePatientMessageReactionActions, req, null)
  return sent.catch((e) => {
    _store.dispatch.call(void 0, patientReactionToggledAction({ ...req, Mine: !mine }))
    throw e
  })
}

const interruptPatientConversationSends = (ConversationKey) =>
  _store.dispatch.call(void 0, patientSendsInterruptedAction({ ConversationKey }))










const uploadPatientFile = async (
  req,
  meta,
) => {
  _store.dispatch.call(void 0, uploadPatientFileActions.REQUEST(req, meta))
  return _uploadFileWithFallback.uploadPatientFileDirect.call(void 0, _client2.default, req.file, req.ConversationKey, { transport: _browserTransport.createBrowserTransport.call(void 0, req.file) }).then((r) => {
    _store.dispatch.call(void 0, uploadPatientFileActions.SUCCESS(r, meta))
    return r
  }).catch((e) => {
    _store.dispatch.call(void 0, uploadPatientFileActions.FAILURE(e, meta))
    throw e
  })
}

// HTTP-shaped action (mirrors uploadPatientFile) — the renewed link is delivered
// only by SMS; the response body is a constant generic payload we never render or log (D1/D3).
const renewPatientConversationLink = async (code) => {
  _store.dispatch.call(void 0, renewPatientConversationLinkActions.REQUEST({ code }, null))
  return _client2.default.renewPatientConversationLink(code)
    .then((r) => {
      _store.dispatch.call(void 0, renewPatientConversationLinkActions.SUCCESS(r, null))
      return r
    })
    .catch((e) => {
      _store.dispatch.call(void 0, renewPatientConversationLinkActions.FAILURE(e, null))
      throw e
    })
}

const sendPatientConversationFile = async (req) => {
  const meta = { lid: _uuid.uuidv4.call(void 0, ), ConversationKey: req.ConversationKey }
  return uploadPatientFile(req, meta)
    .then(Metadata => {
      _helpers.wsCommand(
        'SendPatientConversationMessage',
        sendPatientConversationFileActions,
        { ConversationKey: req.ConversationKey, FileKey: Metadata.FileKey },
        { ...meta, Metadata },
      )
    })
}

exports. default = {
  loadPatientConversationByCode,
  markPatientConversationSeen,
  getPatientConversationMessages,
  sendPatientConversationMessage,
  holdPatientConversationMessage,
  interruptPatientConversationSends,
  togglePatientMessageReaction,
  sendPatientConversationFile,
  renewPatientConversationLink,
}
